export interface SuggestInstantPayDismissalState {
  lastDismissedAt?: string;
  permanentlyDismissed?: boolean;
}

const STORAGE_KEY_PREFIX = "suggest-instant-pay";

export function getSuggestInstantPayStorageKey(workerId: string): string {
  return `${STORAGE_KEY_PREFIX}-${workerId}`;
}
